import React, { useEffect, useState } from "react";
import "../css/ViewEnquiry.css";
import BackgroundImage from "./BackgroundImage";
import icDownloadToExcel from "../img/ic_download_to_excel.png";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { ShimmerButton, ShimmerTitle, ShimmerTable, ShimmerBadge } from "react-shimmer-effects";
import useDownloadToExcel from "./useDownloadToExcelViewEnquiry";


import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";

import DocumentWaitingForAccept from "../components/DocumentWaitingForAccept";

import { } from "@react-pdf/renderer";

import ic_pdf from "../img/ic_pdf.png";

function ViewEnquiry() {


  const [status, downloadToExcel] = useDownloadToExcel();

  const [callingApi, setIsCallingAPI] = useState(false)
  const location = useLocation();
  const dataFromEnquiry = location.state;
  const [initialViewValues, setInitialViewValues] = useState({
    reference: "",
    remarks: "",
    dateTime: "",
    orderNo: "",
    table_row_values: [],
  });

  console.log("data from enquiry ", dataFromEnquiry);

  const callCustomDownloadHook = () => {

    if (initialViewValues.table_row_values) {

      console.log(" initialViewValues.table_row_values ", initialViewValues.table_row_values)

      if (initialViewValues.table_row_values[0].code != "") {
        downloadToExcel(initialViewValues, initialViewValues.table_row_values);
      } else {
        alert("No data to download")
      }


    } else {
      alert("No data to download")
    }

  };

  useEffect(() => {

    setIsCallingAPI(true)

    const apiUrl = `${process.env.REACT_APP_BASE_URL}/Enquiry/${dataFromEnquiry.enquiryNumber}/${dataFromEnquiry.companyCodeForView}`;
    axios
      .get(apiUrl)
      .then((res) => {

        setIsCallingAPI(false)

        console.log("ViewEnquiry API response success ", res.data);
        setInitialViewValues({
          ...initialViewValues,
          reference: res.data[0].ord_H_ref,
          remarks: res.data[0].ord_H_remarks,
          dateTime: res.data[0].ord_H_datetime,
          orderNo: res.data[0].ord_H_no,
          table_row_values: res.data?.map((item, index) => {
            return { ...item, sl_no: (index + 1) }
          }),
        });
      })
      .catch((e) => {

        setIsCallingAPI(false)
        console.log("ViewEnquiry API response error ", e);
      });
  }, []);

  return (
    <div>
      <div className="ViewEnquiry-main-container">
        <h5>View Enquiry</h5>


        {callingApi ?

          <>
            <div >
              <div className="d-flex">
                <ShimmerBadge width={200} />
                <ShimmerBadge width={200} />
              </div>
              <div className="d-flex">
                <ShimmerBadge width={200} />
                <ShimmerBadge width={200} />
              </div>
            </div>


          </>
          :
          <div className="ViewEnquiry-inner-container">

            <div className="d-flex">
              <div className="ViewEnquiry-label-value-container">
                <label>Order No.</label>
                <span className="ViewEnquiry-label-value-colon">:</span>
                <span className="ViewEnquiry-label-value">
                  {initialViewValues.orderNo}
                </span>
              </div>

              <div className="ViewEnquiry-label-value-container">
                <label>Date &amp; Time</label>
                <span className="ViewEnquiry-label-value-colon">:</span>
                <span className="ViewEnquiry-label-value">
                  {initialViewValues.dateTime}
                </span>
              </div>
            </div>

            <div className="d-flex">

              <div className="ViewEnquiry-label-value-container">
                <label>Reference</label>
                <span className="ViewEnquiry-label-value-colon">:</span>
                <span className="ViewEnquiry-label-value">
                  {initialViewValues.reference}
                </span>
              </div>
              <div className="ViewEnquiry-label-value-container">
                <label>Your Remarks</label>
                <span className="ViewEnquiry-label-value-colon">:</span>
                <span className="ViewEnquiry-label-value">
                  {initialViewValues.remarks}
                </span>
              </div>
            </div>

          </div>
        }


        <div className="ViewEnquiry-excel-button-container">
          <button className="ViewEnquiry-excel-button" onClick={callCustomDownloadHook}>
            <img src={icDownloadToExcel} alt="placeholder" />{" "}
            <span>Download To Excel</span>
          </button>

          <PDFDownloadLink className="ViewEnquiry-excel-button" document={<DocumentWaitingForAccept dataFromParentPage={initialViewValues} />} fileName={`premier_no_${initialViewValues.orderNo}.pdf`}>

            {({ blob, url, loading, error }) =>
              loading ?
                'Loading document...' :
                <span className="Download-to-button">
                  <img src={ic_pdf} alt="placeholder" />{" "}
                  'Download to PDF'
                </span>

            }
          </PDFDownloadLink>

        </div>

        <div className="View_Enquiry_list_table_container">

          {callingApi ?
            <div >

              <ShimmerTable row={10} />
            </div>
            :
            <table className="ViewEnquiry-table">
              <thead>
                <tr>
                  <th>Sl.No.</th>
                  <th>Part Number</th>
                  <th>Description</th>
                  <th>Qty Req</th>
                </tr>
              </thead>
              <tbody>
                {initialViewValues.table_row_values.map((item, index) => {
                  return (
                    <tr key={index} className="HomePage-accepted-row-bg">
                      {console.log(" enquiry item ", item)}
                      <td>{index + 1}</td>
                      <td>{item.code}</td>
                      <td>{item.description}</td>
                      <td>{item.req_ty}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

          }



        </div>

        <BackgroundImage />
      </div>


      <div >

        <PDFViewer width={"100%"}>
          <DocumentWaitingForAccept dataFromParentPage={initialViewValues} />
        </PDFViewer>
      </div>

    </div>
  );
}

export default ViewEnquiry;
